import {SubPageMenuListItemButton} from "base/component/presentational";

import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";
import TopicOutlinedIcon from "@mui/icons-material/TopicOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import {ChangesMenuListItemButtom, ChangesSubPageMenu} from "changes/presentational";

const ColectorSubPageMenu = ({colector}) => {
    return (
        <ChangesSubPageMenu
            pending_status={colector.pending_status}
            headingPrimaryText={colector.nome || colector.codigo || colector.id}
            headingSecondaryText="Colector"
        >
            <SubPageMenuListItemButton
                to="summary"
                text="Ficha"
                icon={<AssignmentOutlinedIcon />}
            />
            <SubPageMenuListItemButton
                to="detail"
                text="Datos"
                icon={<ViewListOutlinedIcon />}
            />
            <ChangesMenuListItemButtom entity={colector} />
        </ChangesSubPageMenu>
    );
};

export default ColectorSubPageMenu;
